
import { Button, Divider, Grid, Typography } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { useAppDispatch } from "../../../redux/hooks";

import { IBatchTrackingNumber } from "../../../models/batches/batchTrackingNumber";
import { putWorkOrderTrackingNumber } from "../../../redux";
import '../../../themes/styles.css';


interface Props {
    onCancel: () => void,
    batchTrackingNumber: IBatchTrackingNumber,
    idParent?: string
}

export const MyForm = ({ onCancel, batchTrackingNumber, idParent }: Props) => {
    const dispatch = useAppDispatch();

    const onSave = (batchTrackingNumber: IBatchTrackingNumber) => {
        if (batchTrackingNumber.trackingNumber && idParent)
            dispatch(putWorkOrderTrackingNumber(batchTrackingNumber.id, batchTrackingNumber.trackingNumber, +idParent));
    }
    return (
        <Grid>
            <Typography id="modal-modal-title" variant="h6" component="h2">
                Work Order
            </Typography>
            <br />
            <Divider />
            <br />

            <Formik
                initialValues={batchTrackingNumber}
                onSubmit={(values) => {
                    onSave(values as any);
                    onCancel();
                }}
            // validationSchema={Yup.object({
            //     name: Yup.string()
            //         .max(15, 'Debe de tener 15 caracteres o menos')
            //         .required('Requerido'),
            // })}
            >

                {(formik) => (
                    <Form>
                        <Grid container justifyContent="center" rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                <Typography component="label" htmlFor="trackingNumber">Tracking Number</Typography>
                                <Field name="trackingNumber" type="text" />
                                <ErrorMessage name="trackingNumber" component="span" className="error-message" />
                                <br />
                            </Grid>
                        </Grid>
                        <br />
                        <Grid container justifyContent="center">
                            <Button variant="outlined" type="reset" sx={{ width: 100 }} onClick={onCancel}>Cancel</Button>
                            &nbsp;&nbsp;&nbsp;
                            <Button variant="contained" type="submit" sx={{ width: 100 }} >Save</Button>
                        </Grid>
                    </Form>
                )
                }
            </Formik>
        </Grid >
    )
}

